var _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbProdSkeleton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 340,
    "aria-labelledby": "loading-aria",
    viewBox: "0 0 1220 430",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: 100,
    rx: 5,
    ry: 5,
    fill: "#f5f5f5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 120,
    width: "100%",
    height: 104,
    rx: 5,
    ry: 5,
    fill: "#f5f5f5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 240,
    width: "100%",
    height: 104,
    rx: 5,
    ry: 5,
    fill: "#f5f5f5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    clipPath: "url(#gb-prod-skeleton_svg__clip-path)",
    fill: "url(#gb-prod-skeleton_svg__fill)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gb-prod-skeleton_svg__fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.6,
    stopColor: "#e0dfe2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.6,
    stopColor: "#fff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "2s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "gb-prod-skeleton_svg__clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    rx: 3,
    ry: 3,
    width: 100,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 38,
    rx: 13,
    ry: 13,
    width: "45vw",
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 145,
    rx: 3,
    ry: 3,
    width: 100,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 158,
    rx: 13,
    ry: 13,
    width: "45vw",
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 265,
    rx: 3,
    ry: 3,
    width: 100,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 278,
    rx: 13,
    ry: 13,
    width: "45vw",
    height: 24
  })))));
}
export default SvgGbProdSkeleton;